import { gql, TypedDocumentNode } from '@apollo/client'
import { educationSubjectFragment } from './EducationSubjectFragment'
import type { EmployeeEducationFragment } from './__generated__/EmployeeEducationFragment'

export const employeeEducationFragment: TypedDocumentNode<EmployeeEducationFragment> = gql`
  ${educationSubjectFragment}

  fragment EmployeeEducationFragment on EmployeeEducation {
    educationSubject {
      ...EducationSubjectFragment
    }
    graduationYear
    id
    institute
  }
`
